import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import BgImg from "../../../images/case-studies/rise-up-king/real-world-back.webp";

function Realworldrise() {
  return (
    <section
      className="real-world-rise p-100 text_white"
      style={{
        backgroundImage: `url(${BgImg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="">
            <h2 className="mb-4 mb-md-5">
              Real-World Results: The Impact of{" "}
              <span className="text-rise-yellow">Rise Up Kings</span> on User
              Engagement and Retention
            </h2>
            <div className="real-world-box">
              <h5>
                <span className="text-rise-yellow">25%</span> increase in user
                engagement
              </h5>
              <p>
                Gamified features and personalized tracking kept users coming
                back, maintaining high engagement
              </p>
            </div>
            <div className="real-world-box left-box">
              <h5>
                <span className="text-rise-yellow">35%</span> growth in content
                consumption
              </h5>
              <p>
                With a vast content library, users consumed podcasts, articles,
                and masterminds regularly.
              </p>
            </div>
            <div className="real-world-box">
              <h5>
                <span className="text-rise-yellow">30%</span> increase in
                retention
              </h5>
              <p>
                The inclusion of achievement tracking and community interaction
                tools resulted in longer-term user retention
              </p>
            </div>
            <div className="real-world-box left-box">
              <h5>
                <span className="text-rise-yellow">1000+</span> active users
              </h5>
              <p>
                Rise Up Kings successfully onboarded over 1000 users, building a
                strong community of like-minded individuals.
              </p>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Realworldrise;
